import { Text } from '@cloudflare/kumo'

/** Same brand assets as Layout's SidebarLogo (light + dark variants). */
export function EnrollLogo({ darkMode }: { darkMode: boolean }) {
  return (
    <img
      src={
        darkMode
          ? 'https://tesset.com/brand/logo-dark.svg'
          : 'https://tesset.com/brand/logo-primary.svg'
      }
      alt="TESSET Hub"
      data-testid="enroll-logo"
      className="w-auto"
      // h-8 is not in the precompiled standalone sheet — size via style.
      style={{ height: 32, maxHeight: 32 }}
    />
  )
}

interface EnrollHeaderProps {
  darkMode: boolean
  title: string
  subtitle?: string
}

/** Brand + title block at the top of the public enrollment page. */
export function EnrollHeader({ darkMode, title, subtitle }: EnrollHeaderProps) {
  return (
    <header className="flex flex-col gap-4 pb-2">
      <EnrollLogo darkMode={darkMode} />
      <div className="flex flex-col gap-1">
        <Text variant="heading2" as="h1">
          {title}
        </Text>
        {subtitle && <Text variant="secondary">{subtitle}</Text>}
      </div>
    </header>
  )
}
